import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export const parseLabelMarkup = (text: string) => {
  // Convert non-string values to empty string
  const safeText = typeof text === 'string' ? text : '';

  if (!safeText) return null;

  const regex = /(<b>.*?<\/b>)|(<a\s+href=['"].*?['"]>.*?<\/a>)/g;
  const parts = safeText.split(regex).filter(Boolean);

  return (
    <>
      {parts.map((part) => {
        if (part.startsWith('<b>') && part.endsWith('</b>')) {
          return <strong key={part}>{part.slice(3, -4)}</strong>;
        }
        if (part.startsWith('<a') && part.endsWith('</a>')) {
          const hrefMatch = /href=['"](.*?)['"]/.exec(part);
          const linkTextMatch = /<a\s+href=['"].*?['"]>(.*?)<\/a>/.exec(part);
          const linkText = linkTextMatch ? linkTextMatch[1] : '';
          const href = hrefMatch ? hrefMatch[1] : '#';
          return (
            <a
              key={part}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#1976d2',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 2,
              }}
            >
              {linkText}
              <OpenInNewIcon sx={{ fontSize: 16, ml: 0.5 }} />
            </a>
          );
        }
        return <span key={part}>{part}</span>;
      })}
    </>
  );
};
